import { useEffect, useContext } from "react";
import "../../../app/App.scss";
import Header from "../elements/Header";
import translate from "@/i18n/translate";
import { AppContext, AppContextInterface } from "@/contexts/AppContext";
import PssSideNav from "./PssSideNav";
import { onScrollChangeHeader } from "../../../static/js/commons";
import ScrollableHeader from "./ScrollableHeader";
import OrgProfileContent from "./OrgProfileContent";
import ApiError from "../elements/ApiError";
import PreviewModal from "@/features/lightcast/PreviewModal";
import UnauthorizedComponent from "@/features/insights/UnauthorizedComponent";
import { usePageTitle } from "@/hooks/usePageTitle";
import { useIntl } from "react-intl";

import { defaultOrganization } from "@/features/common/interfaces/Interface";

export interface BodyProps {
  setSelectedTabView: (tabId: string) => void;
  auth: boolean;
  productView?: "planning" | "navigator";
}

export default function Body({
  setSelectedTabView,
  auth,
  productView
}: BodyProps): JSX.Element {
  const { institution } = useContext<AppContextInterface>(AppContext);
  const pageTitle = institution?.name;
  usePageTitle(pageTitle);

  useEffect(() => {
    setTimeout(() => onScrollChangeHeader(), 300);
  }, []);

  let orgContent;
  if (institution && institution.platformUuid != "") {
    orgContent = (
      <OrgProfileContent
        setSelectedTabView={setSelectedTabView}
        productView={productView}
      />
    );
  } else {
    orgContent = <ApiError containerClasses="api-error margin-top-api-error" />;
  }

  let displayName = institution && institution.name;

  return (
    <>
      {auth ? (
        <>
          <main id="maincontent" className="main-body-container">
            <Header displayName={displayName} productView={productView} />
            <ScrollableHeader displayName={displayName} productView={productView} />
            <div className="insights-hub-body flex-row">
              <PssSideNav
                organization={null}
                pssOrganization={defaultOrganization}
              />

              <div id="main-org-profile-container" className="main-org-profile">
                <div>
                  <div className="page-banner -insights-header">
                    <div className="titles">Insights</div>
                    <div className="description">
                      {translate("app.header.description")}
                    </div>
                  </div>
                  <div className="body -height" id="tab-components">
                    {orgContent}
                  </div>
                </div>
              </div>
            </div>
          </main>

          <PreviewModal></PreviewModal>
        </>
      ) : (
        <UnauthorizedComponent />
      )}
    </>
  );
}
